import React, { Component } from 'react'
import { Div } from '@driftt/tide-core'

import ImportMappingTableRows from './ImportMappingTableRows'

import './style.css'

const ImportMappingTableHeader = () => (
  <thead>
    <tr>
      <td>CSV COLUMN</td>
      <td>SAMPLE INFORMATION</td>
      <td>DRIFT ATTRIBUTE</td>
    </tr>
  </thead>
)

class AccountsImportMappings extends Component {

  render() {
    const { upload, onChange } = this.props
    
    if(!upload) return null

    return (
      <Div className="accounts-import-mappings">
        <table className="drift-table">
          <ImportMappingTableHeader />
          <ImportMappingTableRows upload={upload} onChange={onChange} />
        </table>
      </Div>
    )
  }
}

export default AccountsImportMappings